import GRIGORA_APP from "../../../package.json";
import React, { createContext, useContext, useEffect } from "react";
import { WhiteLabelContext } from "../whitelabel";
import { WEBCLIP_URL } from "../app";
import WebFont from "webfontloader";

const GrigoraVersioningContext = createContext();

const GrigoraVersioning = (props) => {
  const { isWhitelabel, __whitelabel__ } = useContext(WhiteLabelContext) ?? {};

  // Update favicon of whitelabel
  useEffect(() => {
    const favicon = __whitelabel__("favicon", WEBCLIP_URL);

    if (favicon) {
      if (document.querySelector("link[rel='icon']")) {
        document.querySelector("link[rel='icon']").href = favicon;
      } else {
        const faviconLink = document.createElement("link");
        faviconLink.rel = "icon";
        faviconLink.href = favicon;
        document.head.appendChild(faviconLink);
      }
    }
  }, []);

  // Update tailwind colors of whitelabel and font family
  useEffect(() => {
    const primaryColor = __whitelabel__("primaryColor");
    const primaryButtonColor = __whitelabel__("primaryButtonColor");
    const secondaryButtonColor = __whitelabel__("secondaryButtonColor");
    const lightBlueBackgroundColor = __whitelabel__("lightBlueBackgroundColor");
    const redColor = __whitelabel__("redColor");
    const fontFamily = __whitelabel__("fontFamily");

    if (primaryColor) {
      document.documentElement.style.setProperty(
        "--color-ui-blue",
        primaryColor,
      );
    }
    if (primaryButtonColor) {
      document.documentElement.style.setProperty(
        "--color-ui-green",
        primaryButtonColor,
      );
    }
    if (secondaryButtonColor) {
      document.documentElement.style.setProperty(
        "--color-ui-og-blue",
        secondaryButtonColor,
      );
    }
    if (redColor) {
      document.documentElement.style.setProperty("--color-ui-red", redColor);
    }
    if (lightBlueBackgroundColor) {
      document.documentElement.style.setProperty(
        "--color-ui-light-blue-background",
        lightBlueBackgroundColor,
      );
    }

    if (fontFamily) {
      WebFont.load({
        google: {
          families: [fontFamily],
        },
      });
      document.documentElement.style.setProperty("--font-family", fontFamily);
    }
  }, []);

  //Poper Script:
  const UseScript = () => {
    useEffect(() => {
      var poperScript = null;
      var lemonScript = null;
      var tawkScript = null;

      if (!isWhitelabel) {
        // if (
        //   !process.env.REACT_APP_NODE_ENV ||
        //   process.env.REACT_APP_NODE_ENV === "development"
        // ) {
        //   return;
        // }

        // Poper.js
        poperScript = document.createElement("script");
        poperScript.id = "poper-js-script";
        poperScript.setAttribute(
          "data-account-id",
          "9de03641f389279fae9fbf39baeef5f0",
        );
        poperScript.src = "https://app.poper.ai/share/poper.js";
        document.body?.appendChild?.(poperScript);

        // Poper config
        window.Poper = window.Poper || [];
        window.Poper.push({
          accountID: "9de03641f389279fae9fbf39baeef5f0",
        });

        // LemonSqueezy
        lemonScript = document.createElement("script");
        lemonScript.src = "https://app.lemonsqueezy.com/js/lemon.js";
        lemonScript.defer = true;
        document.body?.appendChild?.(lemonScript);

        // Tawk.to
        tawkScript = document.createElement("script");
        tawkScript.async = true;
        tawkScript.src =
          "https://embed.tawk.to/68936a077327e01927756b8e/1j1vtcc6h";
        tawkScript.charset = "UTF-8";
        tawkScript.setAttribute("crossorigin", "*");
        // Insert before first script tag
        document.body?.appendChild?.(tawkScript);

        // Tawk.to global variables
        window.Tawk_API = window.Tawk_API || {};
        window.Tawk_LoadStart = new Date();
      }

      return () => {
        // if (
        //   !process.env.REACT_APP_NODE_ENV ||
        //   process.env.REACT_APP_NODE_ENV === "development"
        // ) {
        //   return;
        // }
        if (!isWhitelabel) {
          if (poperScript) {
            if (document.body.contains(poperScript)) {
              document.body.removeChild(poperScript);
            }
          }
          if (lemonScript) {
            if (document.body.contains(lemonScript)) {
              document.body.removeChild(lemonScript);
            }
          }
          if (tawkScript) {
            if (document.body.contains(tawkScript)) {
              document.body.removeChild(tawkScript);
            }
          }
        }
      };
    }, [isWhitelabel]);
  };

  return (
    <GrigoraVersioningContext.Provider
      value={{
        version: GRIGORA_APP.version,
        versionName: GRIGORA_APP.versionName,
      }}
    >
      <UseScript />
      {props.children}
    </GrigoraVersioningContext.Provider>
  );
};
export { GrigoraVersioning, GrigoraVersioningContext };
